<template>
  <div
    :id="message.id"
    class="message-content"
    :class="{
      'client-side': user.isCustomer,
      'agent-side': !user.isCustomer,
      rtl: dir == 'rtl',
    }"
  >
    <div class="avatar" v-if="!user.isCustomer">
      <el-avatar
        :size="32"
        :src="formateAvatar(user.avatar)"
        slot="reference"
        alt="Avatar"
      ></el-avatar>
    </div>
    <div class="content">
      <div class="name" v-if="!user.isCustomer">
        {{ user.nickname || user.username || user.firstName + user.lastName }}
      </div>
      <div class="text-box">
        <!--text-nolink-->
        <slot></slot>
        <div
          class="text"
          v-html="user.isCustomer ? checkUri(message.content) : message.content"
        ></div>
      </div>

      <div class="time">{{ message.createAt }}</div>
    </div>
  </div>
</template>

<script>
import { checkUri } from "@/plugins/filters.js";
export default {
  name: "chat-message-text",
  props: {
    message: {
      type: Object,
    },
    user: {
      type: Object,
    },
  },
  data() {
    return {
      checkUri,
    };
  },
  methods: {
    formateAvatar(url) {
      if (url) {
        return process.env.VUE_APP_BASEURL + url;
      } else {
        return require("@/assets/images/avatar-3.jpg");
      }
    },
  },
  computed: {
    dir() {
      return this.$store.state.global.dir;
    },
  },
};
</script>

<style lang="scss">
@import "chat.scss";
</style>
